import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/context/LanguageContext';

const FloatingButtons = () => {
  const phoneNumber = '+966593591595';
  const { currentLang } = useLanguage();
  const whatsappMessage = encodeURIComponent(
    currentLang === 'ar'
      ? 'مرحباً، أود الاستفسار عن خدمات تصميم المطابخ'
      : 'Hello, I would like to inquire about your kitchen design services.'
  );

  return (
    <div className="fixed bottom-6 end-6 z-40 flex flex-col gap-3">
      {/* Phone Button */}
      <motion.a
        href={`tel:${phoneNumber}`}
        data-testid="floating-phone"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="w-14 h-14 bg-brand-panel border border-white/10 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow"
      >
        <Phone size={22} className="text-white" />
      </motion.a>

      {/* WhatsApp Button */}
      <motion.a
        href={`https://wa.me/${phoneNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: 'spring' }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow"
      >
        <MessageCircle size={24} className="text-white" />
      </motion.a>
    </div>
  );
};

export default FloatingButtons;
